// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"6ce81044","893":"268953a5","932":"d3601fc9"}[chunkId] + ".chunk.css";
};